import React from "react";
import { observer } from "mobx-react";
import { AccommodationEventLogStore } from "./AccommodationEventLogStore";
import { EventLog_AccommodationEventFragment as Event } from "@graphql";
import { AccommodationEvent } from "./AccommodationEvent/AccommodationEvent";
import CommentBox from "../CommentBox/CommentBox";
import { EventLogLayout } from "../components/EventLogLayout";

type Props = {
  store: AccommodationEventLogStore;
  onUpload?: () => any;
  uploadDisabled?: boolean;
};

@observer
class AccommodationEventLog extends React.Component<Props> {
  componentWillUnmount() {
    this.props.store.unsubscribe();
  }

  renderCommentBox = () => {
    return (
      <CommentBox
        onComment={this.props.store.addComment}
        withButtons={["comment" /*, "reminder", "metInPerson", "SMS","chat", "mail"*/]}
        skipReminder
      />
    );
  };

  renderEvent = (event: Event) => {
    return <AccommodationEvent item={event} store={this.props.store} />;
  };

  renderList = () => {
    const { store } = this.props;

    return (
      <div>
        {store.events.map((item) => (
          <div key={item._id}>{this.renderEvent(item)}</div>
        ))}
      </div>
    );
  };

  render() {
    return (
      <EventLogLayout
        loading={this.props.store.isLoading}
        commentBox={this.renderCommentBox()}
        list={this.renderList()}
        search={null}
      />
    );
  }
}

export default AccommodationEventLog;
